module.exports = __webpack_public_path__ + "img/logo-title.eb31d642.png";